module.exports = __webpack_public_path__ + "manager/img/fake-card.6e8df6a.png";